// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.em-inset .em-zoom-buttons {
    display: none;
}
.em-inset-title {
    font-size: 11px;
}
.em-inset-subtitle {
    font-size: 12px;
}
.em-insets-image text {
    fill: #676767 !important;
}
.em-insets-image .em-inset-title,
.em-insets-image .em-inset-subtitle {
    font-size: 8.5px !important;
}
.em-insets-image .em-inset {
    overflow: visible;
}
.em-insets-image .em-scalebar-label {
    font-size: 8px !important;
    fill: #878787 !important;
}
.em-insets-image .em-scalebar-line {
    stroke: #878787 !important;
}
.em-insets-image line {
    stroke: #696969 !important;
}
.em-insets-image .em-inset-detail-frame {
    stroke: #696969 !important;
}
.em-insets .em-frame {
    /* this will give a frame to inset maps */
    stroke: grey;
    stroke-width: 0.3px !important;
}

/* 'default' overseas inset layout decoration (see buildOverseasInsetsDecoration in insets.js) */
.em-insets-background {
    fill: white;
}
.em-inset-separator-line {
    stroke: black;
    stroke-width: 0.3px;
}
.em-inset-separator-line-thin {
    stroke: black;
    stroke-width: 0.1px;
}
.em-inset-blur-stop {
    stop-color: rgb(255, 255, 255);
}
`, "",{"version":3,"sources":["webpack://./src/css/insets.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,eAAe;AACnB;AACA;IACI,wBAAwB;AAC5B;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,iBAAiB;AACrB;AACA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,yCAAyC;IACzC,YAAY;IACZ,8BAA8B;AAClC;;AAEA,gGAAgG;AAChG;IACI,WAAW;AACf;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,8BAA8B;AAClC","sourcesContent":[".em-inset .em-zoom-buttons {\n    display: none;\n}\n.em-inset-title {\n    font-size: 11px;\n}\n.em-inset-subtitle {\n    font-size: 12px;\n}\n.em-insets-image text {\n    fill: #676767 !important;\n}\n.em-insets-image .em-inset-title,\n.em-insets-image .em-inset-subtitle {\n    font-size: 8.5px !important;\n}\n.em-insets-image .em-inset {\n    overflow: visible;\n}\n.em-insets-image .em-scalebar-label {\n    font-size: 8px !important;\n    fill: #878787 !important;\n}\n.em-insets-image .em-scalebar-line {\n    stroke: #878787 !important;\n}\n.em-insets-image line {\n    stroke: #696969 !important;\n}\n.em-insets-image .em-inset-detail-frame {\n    stroke: #696969 !important;\n}\n.em-insets .em-frame {\n    /* this will give a frame to inset maps */\n    stroke: grey;\n    stroke-width: 0.3px !important;\n}\n\n/* 'default' overseas inset layout decoration (see buildOverseasInsetsDecoration in insets.js) */\n.em-insets-background {\n    fill: white;\n}\n.em-inset-separator-line {\n    stroke: black;\n    stroke-width: 0.3px;\n}\n.em-inset-separator-line-thin {\n    stroke: black;\n    stroke-width: 0.1px;\n}\n.em-inset-blur-stop {\n    stop-color: rgb(255, 255, 255);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
